<template>
	<div class="blog-category-paginator-shell" v-cloak>
		<paginator v-model="pageOptions.pageIndex" v-bind="pageOptions" :disabled="requestActive" @paginate="loadPage"></paginator>
		<p class="blog-category-pagination-error" v-show="errorMessage">{{errorMessage}}</p>
	</div>
</template>




<script>
	import { mixinAxios } from '@/js/shared/VueMixins.js';
	import paginator from '../common/Paginator.vue';

	export default {
		name: 'BlogCategoryPaginator',
		mixins: [mixinAxios],
		components: {
			paginator
		},
		props: {
			fetchUrlBase: { type: String, required: true },
			targetId: { type: String, required: true },
			initialPageIndex: { type: Number, required: false, default: 0 },
			nrRecords: { type: Number, required: true, default: 0 },
			pageSize: { type: Number, required: true, default: 1 }
		},
		data: () => ({
			errorMessage: '',
			loadedPageIndex: 0,
			pageOptions: {
				options: {
					texts: {
						countMultiPage: 'Showing {from} to {to} of {count} posts.',
						countSinglePage: '{count} posts in this category.',
						countSingleItem: '1 post in this category.'
					}
				},
				nrRecords: 0,
				pageSize: 1,
				pageIndex: 0,
				pageSetSize: 5,
				disabled: false
			}
		}),
		mounted() {
			this.loadedPageIndex = this.initialPageIndex;
			this.pageOptions.nrRecords = this.nrRecords;
			this.pageOptions.pageSize = this.pageSize;
			this.pageOptions.pageIndex = this.initialPageIndex;
		},
		methods: {
			getFetchUrl(pageIndex) {
				var base = this.fetchUrlBase.endsWith('/')
					? this.fetchUrlBase
					: `${this.fetchUrlBase}/`;

				return `${base}${pageIndex}/`;
			},
			loadPage(pageIndex) {
				this.errorMessage = '';

				return this.mixinAxios().get(this.getFetchUrl(pageIndex))
					.then((resBlogCategoryPage) => {
						var target = document.getElementById(this.targetId);

						if (target == null) {
							throw new Error('Could not find the blog posts container.');
						}

						target.innerHTML = resBlogCategoryPage.data;
						this.loadedPageIndex = pageIndex;
						this.pageOptions.pageIndex = pageIndex;
					})
					.catch(() => {
						this.pageOptions.pageIndex = this.loadedPageIndex;
						this.errorMessage = 'Could not load that page right now. Please try again.';
					});
			}
		}
	}
</script>




<style scoped>
	[v-cloak] {
		display: none;
	}

	.blog-category-paginator-shell {
		width: 100%;
	}

	.blog-category-pagination-error {
		margin: 0.85rem 0px 0px 0px;
		color: #dc2626;
		font-weight: 600;
		text-align: center;
	}
</style>
